
// Routes that are not within our application.
export const externalRoutes = {
  moblyx: 'https://moblyx.com',
  twitter: 'https://twitter.com/moblyx',
  youtube: 'https://www.youtube.com/channel/UCQq7pOIMvTmeBtGWFOZRhEQ',
  purco: 'https://purinspect.com/purco'
};


// Entry routes for the application.
export const entryRoutes = {
  landing: '/',
  images: '/images',
  login: '/login',
  signUp: '/sign-up',
  legal: '/legal-documents',
  forgotPassword: '/forgot-password',
  dashboard: '/dashboard',
  developer: '/developer',
  purchaseCredits: '/purchase-credits',
  configure: '/configure',
  inspectionList: '/inspection-list',
  inspection: '/inspections',
  inspectionView: '/view-inspection',
  verifyEmail: '/verify-email',
  resetPassword: '/reset-password',
  setPassword: '/set-password',
  myDetails: '/my-details',
  changeEmail: '/change-email',
  adminConsole: '/admin-console',
  purchaseHistory: '/purchase-history',
  earlyProspect: '/early-prospect',
  creditUsage: '/credit-utilization',
  contactUs: '/contact-us',
  contactUsWithDelete: '/contact-us/accountDeletion',
  contactUsExternal: '/contact-us-external',
  accountDeleteExternal: '/account-deletion',
  notFound: '/not-found',
  clientError: '/client-error',
  vehicleMulti: '/multi-model',
};

// Developer sub routes.
export const developerRoutes = {
  developer_example: '/developer/example',
  developer_layouts: '/developer/layouts',
  developer_diagram: '/developer/diagram',
  developer_crash: '/developer/crash',
};

// Configuration sub routes
export const configRoutes = {
  configure_contact_details: '/configure/contact-details',
  configure_locations: '/configure/locations',
  configure_edit_contact_details: '/configure/contact-details/edit',
  configure_users: '/configure/users',
  configure_email_content: '/configure/email-content',
  configure_edit_email_content: '/configure/email-content/edit',
  configure_my_details: '/my-details',

  configure_vehicle: '/configure/vehicles',

  configure_reasons: '/configure/reasons',
  configure_checklists: '/configure/checklists',
  configure_checklist_categories: '/configure/checklists/checklist-categories',
  configure_checklist_items: '/configure/checklists/checklist-items',
  configure_damages: '/configure/damages',
  configure_outcomes: '/configure/outcomes',
  configure_video_options: '/configure/video-options',
  configure_edit_video_options: '/configure/video-options/edit',
  configure_damage_types: '/configure/damages/damage-types',
};

export const legalRoutes = {
  privacy_policy: '/legal-documents/privacy-policy',
  terms_of_use: '/legal-documents/terms-of-use',
  eula: '/legal-documents/end-user-licence-agreement',
};

export const documentationRoutes = {
  user_guide: '/documentation/user-guide.pdf',
};

export const adminRoutes = {
  admin_credit_packages: '/admin-console/credit-packages',
  admin_reg_packages: '/admin-console/registration-packages',
  admin_legal_documents: '/admin-console/legal-documents',
  admin_tax_rates: '/admin-console/tax-rates',
  admin_credit_enquiry: '/admin-console/credit-enquiry',
  admin_package_sales: '/admin-console/package-sales',
  admin_credit_utilization: '/admin-console/credit-utilization',
  admin_unconfirmed_purchases: '/admin-console/unconfirmed-purchases',
  admin_transaction_search: '/admin-console/transaction-search',
  admin_sales_report: '/admin-console/sales-report',
  admin_tax_report: '/admin-console/tax-report',
  admin_revenue_report: '/admin-console/revenue-report',
  admin_company_details: '/admin-console/company-details',
  admin_notifications: '/admin-console/notifications',
  admin_configure_users: '/admin-console/users',
  admin_configure_settings: '/admin-console/settings',
  admin_credit_buckets: '/admin-console/credit-allocation-co',
  admin_credit_alloc: '/admin-console/credit-allocation-customer',
  admin_configure_recipients: '/admin-console/email-recipients',
};

// All routes for the application.
const routeLocations = {
  ...entryRoutes,
  ...developerRoutes,
  ...configRoutes,
  ...legalRoutes,
  ...adminRoutes,
};

export default routeLocations;
